import src from "IMAGE";
export default { src, width: 227, height: 64, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AK6urte5ubnfZWVlX19fX1Rra2tabW1tYWRkZFtnZ2daALGxsdezs7PfZWVlXZ6enpKUlJSSmJiYq5KSkqiTk5OiW3AimNAr+AMAAAAASUVORK5CYII="};
